const userOperation = {
  ADD: "ADD",
  EDIT: "EDIT",
  EDIT_PASSWORD: "EDIT_PASSWORD",
  RESET_PASSWORD: "RESET_PASSWORD",
  DELETE: "DELETE",
}

const userStorage = {
  ACOUNT: "hast-user",
  TOKEN: "hast-user-token",
  IS_INVALID_TOKEN: "hast-user-is-invalid-token",
}

export const userConstants = {
  OPERATION: userOperation,
  STORAGE: userStorage,
}
